module.exports = __webpack_public_path__ + "static/img/infoLocationLeft.a15f789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/infoLocationLeft.png
// module id = wklb
// module chunks = 0